import {
  Point,
  PointLog,
  PointOnSale,
  TotalPoint,
  TotalPointParams,
} from './types'
import client from '../../client'
import { ApiResponse } from '../../types'

export * from './types'

export const list = async () => {
  const data: Point[] = await client.get('/user/points')
  return data
}

export const listLogs = async () => {
  const { data }: ApiResponse<PointLog[]> = await client.get(
    '/user/points/logs'
  )
  return data
}

export const getTotalPoint = async (params: TotalPointParams) => {
  const { data }: ApiResponse<TotalPoint> = await client.get(
    '/user/points/total',
    {
      params,
    }
  )
  return data
}

export const getPointsOnSale = async () => {
  const { data }: ApiResponse<PointOnSale[]> = await client.get(
    '/user/points/onSale'
  )
  return data
}
